import axiosInstance from '@/api/axiosInstance';

export const getListing = async (id) => {
  try {
    const response = await axiosInstance.get(`/listings/${id}`);
    return response.data;
  } catch (error) {
    return error?.response?.data || null;
  }
};

export const createMyListing = async (listingData) => {
  const response = await axiosInstance.post('/users/me/listings', listingData);
  return response.data;
}; 

export const updateMyListing = (listingId, listingData) => {
  return axiosInstance.put(`/users/me/listings/${listingId}`, listingData);
}; 

export const getMyListings = async (params = {}) => {
  const response = await axiosInstance.get('/users/me/listings', { params });
  return response.data;
};

export const getRevenuePreview = async (data) => {
  const response = await axiosInstance.post('/users/me/listings/revenue-preview', data);
  return response.data;
};

export const cancelListing = async (listingId) => {
  const response = await axiosInstance.post(`/users/me/listings/${listingId}/cancellation`);
  return response.data;
};

export const createListingInquiry = async (listingId, types) => {
  const response = await axiosInstance.post(`/listings/${listingId}/inquiries`, { types });
  return response.data;
};
